export class UIMessageModel {
    constructor(source) {
        this.id = source.id;
        this.modifier = source.modifier;
        this.label = source.label;
        this.type = source.type;
        this.handler = source.handler;
    }
}
//# sourceMappingURL=UIMessageModel.js.map